import React, { Component, Fragment } from 'react';
import Dialog from 'material-ui/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Stack from '@mui/material/Stack';
import Search from 'calcite-react/Search';
import moment from 'moment';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import theme from '../../muiTheme';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import { KeyboardDateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import TextField from '@mui/material/TextField';
import DateFnsUtils from '@date-io/date-fns';
import MergeWarningDialog from './MergeWarningDialog'

const styles = {
  errorDialogContent: {
    width: "500px"
  },
  errorDialogTitle: {
    color: theme.palette.accent1Color
  }
};

export class MergeDialog extends Component {

  constructor(props) {
    super(props);

    this.state =
    {
      canMergeIncident: false,
      canMergePerimeters: false,
      searchEnabled: false,
      canSearch: false,
      searchValue: '',
      searchIdentifier: 'UniqueFireIdentifier',
      showPartnerInfo: false,
      searchError: false,
      partnerInfo: null,
      isSearching: false,
      mergeOccurrenceDate: null,
      mergeComments: '',
      mergePerimeters: false,
      assignAcreage: false,
      showingMergeWarningDialog: false,
      childPerimeter: null,
      parentPerimeter: null
    };
  }

  onUserAction = (value) => {
    const searchEnabled = this.state.searchIdentifier !== null && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  findPartner = () => {
    this.setState({
      isSearching: true,
      showPartnerInfo: false,
      searchError: false,
      partnerInfo: null
    });

    window.api.getMergePartner(this.props.incident.attributes.FireOccurenceRecordID, this.state.searchValue, this.state.searchIdentifier).then((response) => {
      this.setState({
        showPartnerInfo: true,
        partnerInfo: response.Record,
        canMergePerimeters: response.CanMergePerimeters,
        canMergeIncidents: response.CanMergeIncidents,
        incidentDisallowMessage: response.IncidentDisallowMessage,
        perimeterDisallowMessage: response.PerimeterDisallowMessage,
        childPerimeter: response.ChildPerimeter,
        parentPerimeter: response.ParentPerimeter,
        isSearching: false,
        searchError: (response === null)
      });
    });
  }

  updateSearchValue = (value) => {
    const searchEnabled = (this.state.searchIdentifier !== null && this.state.searchIdentifier !== '') && (value !== null && value !== '');

    this.setState({
      searchValue: value,
      canSearch: searchEnabled
    });
  }

  warningCancelRequest = () => {
    this.setState({
      canMergeIncident: false,
      searchEnabled: false,
      canMergePerimeters: false,
      canSearch: false,
      searchValue: '',
      searchIdentifier: 'UniqueFireIdentifier',
      showPartnerInfo: false,
      searchError: false,
      partnerInfo: null,
      isSearching: false,
      mergeOccurrenceDate: null,
      mergeComments: '',
      showingMergeWarningDialog: false,
      childPerimeter: null,
      parentPerimeter: null,
      assignAcreage: false
    });

    this.props.onMergeClose();
  }

  updateMergePerimeters = (value) => {

    this.setState({
      mergePerimeters: value
    });
  }

  updateAssignAcreage = (value) => {

    this.setState({
      assignAcreage: value
    });
  }

  showWarning = () => {
    this.setState({
      showingMergeWarningDialog: true
    });
  }

  mergeRecord = () => {
    window.api.mergeRecord(this.props.incident.attributes.FireOccurenceRecordID, this.state.partnerInfo.FireOccurenceRecordID, this.state.mergeOccurrenceDate, this.state.mergeComments, this.state.mergePerimeters, this.state.assignAcreage, this.state.childPerimeter, this.state.parentPerimeter).then((response) => 
    {
      this.setState({
        canMergeIncident: false,
        searchEnabled: false,
        canSearch: false,
        searchValue: '',
        searchIdentifier: 'UniqueFireIdentifier',
        showPartnerInfo: false,
        searchError: false,
        partnerInfo: null,
        isSearching: false,
        mergeOccurrenceDate: null,
        mergeComments: '',
        canMergePerimeters: false,
        childPerimeter: null,
        parentPerimeter: null,
        mergePerimeters: false,
        assignAcreage: false
      });

      this.props.onWasMerged();
    });
  }

  render() {

    const notFoundAlert = (this.state.showPartnerInfo && !this.state.partnerInfo && this.state.searchError) ? (<Alert severity="error">Unique Fire Identifier {this.state.searchValue} not found.</Alert>) : null;

    return (

      <Dialog
        titleStyle={styles.errorDialogTitle}
        title="Merge Incident"
        open={this.props.open}>
        <DialogContent>
          <div>
            <Stack spacing={2} direction="column">
              Parent record Unique Fire Identifier:
              <Search fullWidth label="Identifier" onChange={this.updateSearchValue} inputValue={this.state.searchValue} style={{ width: '250px' }}  onUserAction={this.onUserAction} />
              <Button variant="contained" disabled={!this.state.canSearch} style={{ height: '30px', width: '75px' }} onClick={this.findPartner}>Search</Button>
              {notFoundAlert}
            </Stack>
          </div>
          {(this.state.showPartnerInfo === true && !this.state.searchError) &&

            <div style={{ marginTop: "10px" }}>
              <Typography variant="h6" style={{ color: "#09f" }}>
                Parent Details
              </Typography>
           
            <Grid style={{ maxWidth: "700px"}} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
              <Grid item xs={4}>
                <b>Incident Name:</b>
              </Grid>
              <Grid item xs={8}>
                {this.state.partnerInfo.IncidentName}
              </Grid>
              <Grid item xs={4}>
                <b>Unique Fire Identifier:</b>
              </Grid>
              <Grid item xs={8}>
                {this.state.partnerInfo.UniqueFireIdentifier}
              </Grid>
              <Grid item xs={4}>
                <b>Fire Discovery Date:</b>
              </Grid>
              <Grid item xs={8}>
                {moment(this.state.partnerInfo.FireDiscoveryDateTime).format('MM/DD/YYYY h:mm A')}
              </Grid>
              <Grid item xs={4}>
                <b>Incident Size:</b>
              </Grid>
              <Grid item xs={8}>
                {this.state.partnerInfo.IncidentSize}
              </Grid>
              <Grid item xs={12}>
              <Typography variant="h6" style={{ color: "#09f" }}>
                Merge Info
              </Typography>
              </Grid>
              <Grid item xs={4}>
                <b>Fire Discovery Date:</b>
              </Grid>
              <Grid item xs={8}>
                {moment(this.props.incident.attributes.FireDiscoveryDateTime).format('MM/DD/YYYY h:mm A')}
              </Grid>
              <Grid item xs={4}>
                <b>Date of merge occurrence:</b>
              </Grid>
              <Grid item xs={8}>
              <Fragment>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>

                <KeyboardDateTimePicker
                  ampm={false}
                  value={this.state.mergeOccurrenceDate}
                  onChange={(event, date) => {
                    if (event && !isNaN(event.getTime()))
                    {
                      this.setState({
                        mergeOccurrenceDate: event.getTime()
                      });
                    }
                    else
                    {
                      
                    }
                  }}
                  format="MM/dd/yyyy HH:mm"
                  />
                  </MuiPickersUtilsProvider>
                </Fragment>
              </Grid>
              <Grid item xs={4}>
                <b>Add Child Acreage to Parent?</b>
              </Grid>
              <Grid item xs={8}>
              <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={0}
                onChange={(event) => {
                  this.updateAssignAcreage(event.target.value);
                }}
                name="radio-buttons-group">
                <FormControlLabel control={<Radio />} value={true}  label="Yes" />
                <FormControlLabel value={false} control={<Radio />} label="No" />
              </RadioGroup>
              </FormControl>
              </Grid>
              <Grid item xs={4}>
                <b>Merge Comments:</b>
              </Grid>
              <Grid item xs={8}>
              <TextField defaultValue={this.state.mergeComments}
                  multiline
                  maxRows={5}
                  minRows={5}
                  onChange={(event) => {
                    this.setState({
                      mergeComments: event.target.value
                    });
                  }} />
              </Grid>
              <Grid item xs={4}>
                <b>Combine Perimeters?</b>
              </Grid>
              <Grid item xs={8}>
              <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue={0}
                disabled={!this.state.canMergePerimeters}
                onChange={(event) => {
                  this.updateMergePerimeters(event.target.value);
                }}
                name="radio-buttons-group">
                <FormControlLabel control={<Radio disabled={!this.state.canMergePerimeters} />} value={true} label="Yes" />
                <FormControlLabel value={false} control={<Radio disabled={!this.state.canMergePerimeters}/>} label="No" />
              </RadioGroup>
              </FormControl>
              </Grid>
             
            </Grid>
            </div>
          }
        <MergeWarningDialog
            open={this.state.showingMergeWarningDialog}
            onRequestClose={this.warningCancelRequest}
            mergeRecordConfirmed={this.mergeRecord} />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onMergeClose} color="primary">
            Cancel
          </Button>
          <Button onClick={this.showWarning} disabled={!this.state.mergeOccurrenceDate || this.state.mergeComments === null} color="primary">
            Merge
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default MergeDialog;
